// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da
import Naluri from '~/common/api/naluri';
import {
  PROFILE_UPDATE_BEGIN,
  PROFILE_UPDATE_SUCCESS,
} from './constants';

export function updateProfile(userId, params) {
  return (dispatch) => {
    dispatch({
      type: PROFILE_UPDATE_BEGIN
    });

    return Naluri.put(`/api/expert/profile/${userId}`, params)
    .then(res => {
      dispatch({
        type: PROFILE_UPDATE_SUCCESS
      });
    })
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PROFILE_UPDATE_BEGIN:
      return {
        ...state,
        updateProfilePending: true
      };

    case PROFILE_UPDATE_SUCCESS:
      return {
        ...state,
        updateProfilePending: false
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/profile/redux/updateProfile.js